var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLinkIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 10,
    viewBox: "0 0 20 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 5a1 1 0 001 1h6a1 1 0 100-2H7a1 1 0 00-1 1zm2 3H5a3 3 0 110-6h3a1 1 0 000-2H5a5 5 0 100 10h3a1 1 0 000-2zm7-8h-3a1 1 0 100 2h3a3 3 0 010 6h-3a1 1 0 100 2h3a5 5 0 100-10z",
    fill: "#1D426D"
  })));
}

export default SvgLinkIcon;